import { DEFAULT_SHORTCUTS } from '#pplx/frontend/apps/ask/keyboards/keyboards-core/consts.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { createZustandContext } from '#pplx/frontend/zustand-context/createZustandContext.js';
import { noop } from 'lodash-es';
import { create } from 'zustand';
// Create a Zustand context for the native bridge store
// This enables dependency injection - different platforms can provide their own implementations
const { useSelector, Provider } = createZustandContext('NativeBridgeContext', (initialValue) => {
    return create(initialValue);
});
// React Context Provider component for the native bridge store
export const NativeBridgeStoreProvider = Provider;
// Hook to access the native bridge store from any component
export const useNativeBridgeSelector = useSelector;
/**
 * Hook to access native bridge actions
 * @returns NativeBridge actions
 */
export const useNativeBridgeActions = () => {
    return useNativeBridgeSelector((state) => state.actions);
};
/** Opens `url` through the platform bridge, or in a new browser tab where no bridge handles it. */
export function openLink(actions, url, intent) {
    if (!actions.openLink) {
        window.open(url, '_blank', 'noopener,noreferrer');
        return;
    }
    actions.openLink(url, intent).catch((err) => {
        logger.warn('Failed to open link', { intent, err });
    });
}
export const useManagedFolders = () => {
    return useNativeBridgeSelector((state) => state.managedFolders);
};
// No-op implementation used when no platform-specific bridge is available
// Ensures the app works on unsupported platforms without errors
export const DUMMY_NATIVE_BRIDGE = () => ({
    defaultGlobalShortcuts: DEFAULT_SHORTCUTS,
    keyboardShortcutHandlers: {},
    authStatus: 'loading',
    isLocalBrowserAvailable: false,
    managedFolders: [],
    resolvedSlug: null,
    BridgeComponent: () => null,
    actions: {
        registerShortcut: () => noop,
        publishIpcMessage: noop,
        registerKeyboardShortcutHandler: noop,
        subscribeToIpcMessage: () => () => noop,
        setAuthStatus: () => { },
        openExternalURL: (url) => {
            window.open(url, '_blank');
        },
        registerDeepLinkHandler: () => noop,
    },
});
//# sourceMappingURL=store.js.map